import { Component, OnInit, Input } from '@angular/core';
import { AppService } from 'src/app/services/app.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-manual-resend',
  templateUrl: './manual-resend.page.html',
  styleUrls: ['./manual-resend.page.scss'],
})
export class ManualResendPage implements OnInit {
  @Input() public sendselectedIndex: any;

  public appPages = [
    {
      title: "ค้นหาใบกำกับภาษี",
      url: "/resend",
      action: 1,
      disabled: false,
    },
    {
      title: "เลือกใบกำกับภาษี",
      url: "/resend-select-taxinvoice",
      action: 2,
      disabled: true,
    },
    {
      title: "รายละเอียด",
      url: "/resend-detail",
      action: 3,
      disabled: true,
    }
  ];

  constructor(public appService: AppService,private router: Router) {
  }
  ngOnInit() {
    
  }
  ionViewDidEnter() {
  }

  clickMenu(a) {
    this.appService.setActive(a);
    if (a === 3) {
      this.appService.setActive(2);
    }
  }

  onRouterLink(p) {
    if (p.disabled) return;
    this.router.navigate([p.url]);
  }
}
